import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { useRoute, useRouter } from 'vue-router'
import { hexToUtf8 } from 'web3-utils'
import { onMounted, onUnmounted, ref, shallowRef, type Component } from 'vue'
import { SiweMessage } from 'siwe'

import DefaultSign from './DefaultSign.vue'
import SiweSign from './SiweSign.vue'
import TransactionSign from './TransactionSign.vue'
import { useApprovalsStore } from '@/popup/store/ApprovalsStore'
import { PopupDatabase } from '@/popup/storage/Database'
import { Approval, ApprovalApi, APPROVAL_ACTION } from '@/shared/apis/approvals'
import { InternalMethods } from '@/shared/apis/messages'
import { Sign } from '@/shared/models/Sign'
import { redirectAfterApproval } from '@/popup/utils/redirectAfterApproval'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { useAppStore } from '@/popup/store/AppStore'

// https://eips.ethereum.org/EIPS/eip-4361
const SIWE_PHRASE = ' wants you to sign in with your Ethereum account:\n'


export default /*#__PURE__*/_defineComponent({
  __name: 'Sign',
  setup(__props) {

const appStore = useAppStore()
const router = useRouter()
const route = useRoute()
const id = route.params['id']
const approvalsStore = useApprovalsStore()
const approval = approvalsStore.getApproval(id) as Approval<
  keyof ApprovalApi,
  Sign
>
const message = ref('')
const siwe = ref<SiweMessage>()
const icon = ref<string>('')
const onMountedRun = ref(false)
const validationInterval = ref<number>()
const origin = ref<string>()
const signComponent = shallowRef<Component>()

onMounted(async () => {
  const dbOrigin = await PopupDatabase.getOrigin(encodeURI(approval.origin))
  icon.value = dbOrigin?.icon as string

  try {
    message.value = hexToUtf8(approval?.requestData.message)
  } catch {
    message.value = approval?.requestData.message
  }

  const signType = message.value.includes(SIWE_PHRASE)
    ? 'SIWE'
    : approval.requestData.type === 'MESSAGE'
    ? 'MESSAGE'
    : 'TRANSACTION'

  signComponent.value = {
    SIWE: SiweSign,
    MESSAGE: DefaultSign,
    TRANSACTION: TransactionSign,
  }[signType]

  origin.value =
    approval.requestData.type === 'SIWE' ? siwe.value?.domain : approval.origin
  onMountedRun.value = true
})

onUnmounted(() => {
  if (validationInterval.value) {
    clearInterval(validationInterval.value)
  }
})

const onApprovalClose = async (
  action: APPROVAL_ACTION,
  validationFn?: () => void
) => {
  validationFn?.()
  const approvalDirective = await useGlobals().sendMessage({
    method: InternalMethods.HANDLE_APPROVAL,
    payload: {
      action,
      requestId: approval.id,
    },
  })
  approvalsStore.processDirective(approvalDirective)

  redirectAfterApproval(
    router,
    approvalsStore.nonStashedApprovals.length,
    appStore.lastPopupState?.path
  )
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sign-screen", { loaded: onMountedRun.value }])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(signComponent.value), {
      approval: _unref(approval),
      origin: origin.value && encodeURI(origin.value),
      message: message.value,
      icon: icon.value,
      onOnApprovalClose: onApprovalClose
    }, null, 40 /* PROPS, NEED_HYDRATION */, ["approval", "origin", "message", "icon"]))
  ], 2 /* CLASS */))
}
}

})